<template>
  <navbar v-if="!isLoginPage && !isNotFoundPage"></navbar>
  <RouterView :class="[
    { 'lg:pr-64': sidebarOpen, 'lg:pr-0': !sidebarOpen },
    !isLoginPage && !isNotFoundPage ? 'pt-16 lg:pt-8' : 'mt-8',
    'transition-all duration-300 ease-in-out'
  ]" />
</template>

<script>
import Navbar from './components/Navbar.vue';

export default {
  name: 'App',
  components: {
    Navbar
  },
  data() {
    return {
      sidebarOpen: true, // Default to open, matching Navbar default
    };
  },
  computed: {
    isLoginPage() {
      return this.$route.path === '/';
    },
    isNotFoundPage() {
      return this.$route.name === 'NotFound';
    },
  },
  mounted() {
    // Listen for sidebar toggle events from Navbar component
    window.addEventListener('sidebarToggle', this.handleSidebarToggle);
  },
  beforeUnmount() {
    // Clean up event listener
    window.removeEventListener('sidebarToggle', this.handleSidebarToggle);
  },
  methods: {
    handleSidebarToggle(event) {
      this.sidebarOpen = event.detail.isOpen;
    },
  },
};
</script>

<style scoped></style>

